import { render, staticRenderFns } from "./Yellow.vue?vue&type=template&id=28ee27ae&"
import script from "./Yellow.vue?vue&type=script&lang=js&"
export * from "./Yellow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports